import { Modal } from "antd";
import styled from "styled-components";

const ErrorModal = styled(Modal)`
  .ant-modal-content {
    font-family: veterantypewriter !important;
    background: #222831;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  }
  .ant-modal-header {
    background: #222831;
    border-radius: 12px 12px 0 0;
  }
  .ant-modal-title {
    color: #8e1616;
    font-weight: 700;
  }
  .ant-modal-body {
    background: #222831;
    color: #eeeeee;
  }
  .ant-modal-footer {
    background: #222831;
    margin-top: 0;
  }
  .ant-btn-primary {
    font-family: veterantypewriter !important;
    background: #8e1616 !important;
    border-color: #8e1616 !important;
    color: #eeeeee !important;
    &:hover {
      background: #6e1010 !important;
      border-color: #6e1010 !important;
    }
  }
  .ant-modal-close {
    color: #eeeeee;
    &:hover {
      color: #8e1616;
      background: #393e46;
    }
  }
`;

export default ErrorModal;
